module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 48
// module chunks = 0